import axios from "axios";
import apiUrlOne from "../Config";


// Get all categories (admin)
export const getAllCategoriesAdmin = async (query = {}) => {
    // query can include { limit, page, search, status } etc.
    const response = await axios.get(
        `${apiUrlOne}/categories/getall-categories-admin`,
        { params: query }
    );
    return response.data; // { data: [...], totalPages, totalItems, page, message, status }
};



// Create category
export const createCategory = async (formData) => {
    const response = await axios.post(`${apiUrlOne}/categories/create-category`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Update category
export const updateCategory = async (id, formData) => {
    const response = await axios.put(`${apiUrlOne}/categories/update-category/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Delete category
export const deleteCategory = async (id) => {
    const response = await axios.delete(`${apiUrlOne}/categories/delete-category/${id}`);
    return response.data;
};


export const getCategoryById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/categories/get-category/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching category:", error);
        throw error;
    }
};


